import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  userLoggedIn() {
    return !!localStorage.getItem('token');
  }

  isAssetConfirm() {
    return !!localStorage.getItem('isAssetConfirm')
  }

}
